import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import { RouteUtils } from "utilities/route-utils";
import { siteMap } from "internal-sitemap";
import { useHistory } from "react-router";
import React, { forwardRef } from "react";
import NotebookRecord from "models/view-models/notebook-record";

export interface OpenNotebookMenuItemProps extends ButtonProps {
    notebook: NotebookRecord;
}

const OpenNotebookMenuItem = forwardRef<
    HTMLButtonElement,
    OpenNotebookMenuItemProps
>((props, ref) => {
    const { notebook } = props;
    const { t } = useLocalization();
    const history = useHistory();

    const notebookRoute = (notebookId) =>
        RouteUtils.getUrl(siteMap.notebooks.notebook.detail, {
            notebookId: notebookId,
        });

    const handleOpenNotebook = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.currentTarget.blur();

        const route = notebookRoute(notebook.id);
        history.push(route);
    };

    return (
        <Button
            accessibleText={t("openItem", {
                item: t("notebook"),
            })}
            cssClassName={"-icon-left"}
            onClick={handleOpenNotebook}>
            <Icon type={Icons.Notebook}></Icon>
            {t("openNotebook")}
        </Button>
    );
});

export default OpenNotebookMenuItem;
